import React from 'react';
import { Result, Button, Layout } from 'antd';

const { Content } = Layout;

const PageNotFound = () => {
  const goBack = () => {
    window.location.replace('/');
  };

  return (
    <Content className='content-main site-layout-background'>
      <div>
        <Result
          status='404'
          title='404'
          subTitle='Sorry, the page you visited does not exist.'
          extra={
            <Button type='primary' onClick={goBack}>
              Back Home
            </Button>
          }
        />
      </div>
    </Content>
  );
};

export default PageNotFound;
